import React, { type ReactNode } from 'react';
import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import { Illustration } from '@atlassian/jira-illustration';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations';
import { srcLight as GenericError } from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/generic-error';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export type ErrorScreenProps = {
	onClick?: () => void;
	illustration?: string;
	header: string;
	headingLevel?: number;
	description?: ReactNode;
	buttonMessage?: ReactNode;
	testId?: string;
	maxImageWidth?: number;
	maxImageHeight?: number;
};

export const ErrorScreen = ({
	onClick,
	illustration = GenericError,
	header,
	headingLevel,
	description,
	buttonMessage,
	testId,
	maxImageWidth = 160,
	maxImageHeight = 288,
}: ErrorScreenProps) => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			testId={testId}
			header={header}
			headingLevel={headingLevel}
			description={description}
			maxImageWidth={maxImageWidth}
			maxImageHeight={maxImageHeight}
			renderImage={getAkEmptyStateRenderImageFn(() => (
				<Illustration
					srcLight={illustration}
					srcDark={illustration}
					alt=""
					autoDark={false}
					width="100%"
				/>
			))}
			primaryAction={
				onClick && (
					<Button appearance="primary" onClick={onClick}>
						{buttonMessage || formatMessage(messages.refresh)}
					</Button>
				)
			}
		/>
	);
};
